/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import {DiscoveryPage} from '@app/components/discovery/DiscoveryPage';
import {DiscoverySidebar} from '@app/components/discovery/DiscoverySidebar';
import {DiscoveryGuildHeader} from '@app/components/layout/DiscoveryGuildHeader';
import styles from '@app/components/layout/GuildLayout.module.css';
import {GuildSidebar} from '@app/components/layout/GuildSidebar';
import DiscoveryStore from '@app/stores/DiscoveryStore';
import MobileLayoutStore from '@app/stores/MobileLayoutStore';
import {observer} from 'mobx-react-lite';
import {useEffect} from 'react';

export const DiscoveryLayout = observer(function DiscoveryLayout() {
	const isMobile = MobileLayoutStore.enabled;

	useEffect(() => {
		void DiscoveryStore.loadCategories();
		void DiscoveryStore.search({offset: 0});
		return () => {
			DiscoveryStore.reset();
		};
	}, []);

	if (isMobile) {
		return <DiscoveryPage />;
	}

	return (
		<div className={styles.guildLayoutContainer}>
			<div className={styles.guildLayoutContent}>
				<GuildSidebar header={<DiscoveryGuildHeader />} content={<DiscoverySidebar />} />
				<div className={styles.guildMainContent}>
					<DiscoveryPage />
				</div>
			</div>
		</div>
	);
});
